const ART_WIDTH = 40

const art = `   ▒▓█████             ▓███████████████
  ██████████             ▓██████████████
 █████████████             ▓████████████
████████████████             ▓██████████
██████████████████             ▓████████
█████████████████████            ▓██████
████████████████████▓▒             ▓████
██████████████████▒                  ▓██
████████████████▒                      ▓
██████████████▒           ▒██
████████████▒           ▒▓█████
██████████▒           ▒██████████
████████▒          ▒▓▓█████████████
██████▒          ▒███████████████████
████▒          ▒▓██████████████████████
██▒          ▒██████████████████████████
▒          ▒▓███████████████████████████
         ▒█████████████████████████████▒
       ▒▓████████████████████████████
      ▓████████████████████████████     `

export function printWelcome(version: string): void {
  const text = `Welcome to Turing v${version}`
  const pad = Math.max(0, Math.floor((ART_WIDTH - text.length) / 2))
  console.log('%c' + art + '\n\n' + ' '.repeat(pad) + text + '\n', 'color:#009983;font-size:14px;font-weight:bold;')
}
